export default "__VITE_ASSET__Dm86PnVv__"